import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { PriceLogBaseModel } from "./priceLogBaseModel"
import { PriceChangeType } from "../../constants/priceChangeType"
import { SubAreaModel } from "../subAreaModel"

@Serializable
export class PriceLogChangeModel extends PriceLogBaseModel {
  constructor(
    data: {
      uid: string
      changeType: PriceChangeType
      created: string
      createdByName: string
      createdByEmail: string
      comment: string
      subAreasFrom: SubAreaModel[]
      subAreasTo: SubAreaModel[]
    } | null = null,
  ) {
    super(data)
  }
}
